import { NavBarStyles } from './constants';

export const dismissBoundaryOffset =
  NavBarStyles.navBarHeightPx - NavBarStyles.navBarMenuVerticalOffsetPx;
